var map = {
	"./favicon.ico": "43FW"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4B8H";


//////////////////
// WEBPACK FOOTER
// ./src/assets nonrecursive ^\.\/favicon.(png|jpe?g|svg|ico)$
// module id = 4B8H
// module chunks = 1